import React, { useEffect, useState } from "react";
import { array, string, object, bool } from "prop-types";

import Organism3 from "../Row2/Organism3";
import DfpAd from "../../../dfp-ad";

import "./column.m.css";

const Column = ({ stories, collectionSlug, publisherAttributes, updatedFont, src, adSlotId }) => {
  const [isDesktop, setIsDesktop] = useState(true);
  const [userAgent, setUserAgent] = useState(false);

  useEffect(() => {
    global.deviceWidth < 876 && setIsDesktop(false);
    global.navigator.userAgent.includes("Mobile") && setUserAgent(true);
  }, []);

  return (
    <div styleName="base">
      <div styleName="ad-slot">
        {!userAgent ? (
          <DfpAd
            adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R1" : "Home_336x280_R1"}
            collectionSlug={collectionSlug}
            layoutName="FourteenStories3Ad1Widget"
            slotId={adSlotId}
          />
        ) : null}
      </div>
      {stories.length > 0 && (
        <Organism3
          stories={stories.splice(0, 2)}
          updatedFont={updatedFont}
          src={src}
          lang={publisherAttributes.lang}
          firstCardAspectRatio={isDesktop ? [16, 9] : [3, 2]}
          changeImageType={isDesktop ? "image16x9" : "image3x2"}
        />
      )}
    </div>
  );
};

Column.propTypes = {
  stories: array.isRequired,
  collectionSlug: string,
  publisherAttributes: object,
  updatedFont: bool,
  src: string,
  adSlotId: string,
};

export default Column;
